// @flow

// COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
import Typeahead from 'fg-frontend/components/Typeahead';

// COMMON: Komponenta pro zapnuti/vypnuti viditelnosti vkladaneho hesla (odeberte, pokud nepouzivate registration modul)
// import PasswordToggle from 'fg-frontend/components/PasswordToggle';

// COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
import SocialShare from 'fg-frontend/components/SocialShare';

// COMMON: Komponenta, ktera zajistuje, ze se vertikalni menu zobrazi vzdy pouze v jednom radku (odeberte, pokud na hlavni navigaci nepouzivate)
import GreedyMenu from 'fg-frontend/components/GreedyMenu';

// COMMON: Komponenta webslideru (odeberte, pokud tuto promitacku nepouzivate)
// import Webslider from 'fg-frontend/src/components/Webslider';

// COMMON: Napovedne popupy (odeberte, pokud v projektu nepouzivate, na eshopu napriklad na napovedy k parametrum a jako obecna knihovna pro zobrazovani napovednych textu)
import Tooltip from './components/Tooltip';

// COMMON: Komponenta, ktera upoznuje posilat do GTM Datalayeru zaznamu na zaklade zapisu v data atributech (odeberte, pokud GTM nepouzivate, jinak vyuzito primarne v eshopu)
import GtmHandler from './components/GtmHandler';

// COMMON: Komponenta, ktera vystreli specialni udalost v okamziku, kdy se objevi ve viewportu (pomocna komponenta pro GtmHandler, odeberte, pokud nepouzivate GTMHandler]
import TriggerInViewport from './components/TriggerInViewport';

// COMMON: Komponenta, ktera nastavi obrazek do rezimu lazy (odeberte, pokud nepouzivate lazy obrazky)
import LazyImage from './components/LazyImage';

// COMMON: Komponenta pro prepinani HTML tridy na danem elementu
import Toggler from './components/Toggler';

// COMMON: Komponenta pro multi upload souboru (odeberte, pokud nepouzivate RJ fileUpload komponentu)
import FGUpload from './components/FGUpload';

// COMMON: custom implementace komponenty AlertBox
import CustomAlertBox from './components/CustomAlertBox';

// COMMON: Komponenta pro odpocet
// import Countdown from './components/Countdown';

// COMMON: Komponenta pro rozbaleni dalsich fotografii (TODO PDU: nahradit obecnejsi komponentou ListToggle)
// import ShowMorePhotos from './components/ShowMorePhotos';

// COMMON: Komponenta pro AJAX nacteni SVG spritu
import AddSvgIconSprite from './components/AddSvgIconSprite';

// COMMON: Komponenta pro nacteni zakladniho instagram feedu
// import InstagramFeed from './components/InstagramFeed';

// COMMON: Komponenta pro galerii fotek
import PhotoSwipe from './components/PhotoSwipe';

// COMMON: Komponenta pro hlavičku
import Header from './components/Header';

// COMMON: Komponenta pro scroll na kotvu
import AnchorSlider from './components/AnchorSlider';

// COMMON: Komponenta pro označování klíčových slov v textu
import Glossary from './components/Glossary';

import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';

import SimpleSlider from './components/SimpleSlider';

import GallerySwiper from './components/GallerySwiper';

import CopyToClipboard from './components/CopyToClipboard';

import Tabs from './components/Tabs';

import CalculatorEasy from './components/CalculatorEasy';

import CalculatorKredit from './components/CalculatorKredit';

// Komponenty pouzite primarne v eshopu (odkomentujte v pripade eshopu, ale pozor obsahuje i univerzalne pouzitelne komponenty, pokud potrebujete, nebojte se pouzit - tj. presunout sem)
// import configureEshopComponents from './configureEshopComponents';

export default (props) => {
  switch (props.decorator || props.is) {
    case 'GreedyMenu':
      return GreedyMenu;
    case 'Typeahead':
      return Typeahead;
    case 'PasswordToggle':
      return PasswordToggle;
    case 'SocialShare':
      return SocialShare;
    case 'Webslider':
      return Webslider;
    case 'Tooltip':
      return Tooltip;
    case 'GtmHandler':
      return GtmHandler;
    case 'TriggerInViewport':
      return TriggerInViewport;
    case 'LazyImage':
      return LazyImage;
    case 'Toggler':
      return Toggler;
    case 'FGUpload':
      return FGUpload;
    case 'Countdown':
      return Countdown;
    case 'ShowMorePhotos':
      return ShowMorePhotos;
    case 'CustomAlertBox':
      return CustomAlertBox;
    case 'InstagramFeed':
      return InstagramFeed;
    case 'AddSvgIconSprite':
      return AddSvgIconSprite;
    case 'PhotoSwipe':
      return PhotoSwipe;
    case 'Header':
      return Header;
    case 'AnchorSlider':
      return AnchorSlider;
    case 'UniversalPaginationButton':
      return UniversalPaginationButton;
    case 'Glossary':
      return Glossary;
    case 'SimpleSlider':
      return SimpleSlider;
    case 'GallerySwiper':
      return GallerySwiper;
    case 'CopyToClipboard':
      return CopyToClipboard;
    case 'Tabs':
      return Tabs;
    case 'CalculatorEasy':
      return CalculatorEasy;
    case 'CalculatorKredit':
      return CalculatorKredit;
    default:
      /* const eshopComponent = configureEshopComponents(props);
      if (eshopComponent) {
        return eshopComponent;
      } else {
        console.log(`Unknown component ${props.decorator || props.is}`);
        return null;
      } */
      console.log(`Unknown component ${props.decorator || props.is}`);
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js